import { MONTHS } from '../constants/month';
import { getPageWidth } from '../utils/getPageWidth';
/**
 * Подходит для формата дат, dataLabel на начало каждого месяца:
 * datesLabels: [ '2020-01-01', '2020-02-01', '2020-03-01', '2020-04-01', '2020-05-01' ],
 * Фильтрует:
 *  - если данных до 1 года - выводим каждый 2-й месяц (в мобайле - каждый 4й)
 *  - если данных от 1 до 3 лет - выводим каждый 4-й месяц (в мобайле - каждый 6й)
 *  - если данныы от 3 лет - выводим каждый 6-й месяц (в мобайле - каждый 12й, т.е год)
 * */
var _getDividerByTicks = function _getDividerByTicks(ticks, pageWidth) {
  var ticksLength = ticks.length;
  var isMoreOneYear = ticksLength >= 12 && ticksLength < 36;
  var isMoreThreeYear = ticksLength >= 36;
  var divider = isMoreOneYear ? 4 : isMoreThreeYear ? 6 : 2;
  if (pageWidth < 641) {
    divider = isMoreOneYear ? 6 : isMoreThreeYear ? 12 : 4;
  }
  return divider;
};
var _filterVariantA = function _filterVariantA(scale) {
  var pageWidth = getPageWidth();
  var divider = _getDividerByTicks(scale.ticks, pageWidth);
  return function (tickIndex, tick) {
    if ((tickIndex + 1) % divider === 0) {
      var tickDate = new Date(tick.value);
      return "".concat(MONTHS[tickDate.getMonth()], " '").concat(String(tickDate.getFullYear()).substr(2));
    }
    return '';
  };
};

/**
 * Подходит для формата дат, dataLabel на каждый день:
 * datesLabels: [ '2020-01-01', '2020-01-02', '2020-01-03', '2020-01-04', '2020-01-05' ],
 * Фильтрует:
 *  - оставляет только начало каждого месяца
 * */
var _filterVariantB = function _filterVariantB() {
  return function (index, tick) {
    var tickDate = new Date(tick.value);
    var tickDayIndex = tickDate.getDate();
    if (tickDayIndex === 1) {
      return MONTHS[tickDate.getMonth()];
    }
    return '';
  };
};

/**
 * Фильтр тиков по оси Х
 * Путь в chartjs конфиге: cfg.options.scales.x.afterTickToLabelConversion
 * */
var _afterTickToLabelConversion = function _afterTickToLabelConversion(createGetLabel) {
  return function (scale) {
    try {
      var getLabel = createGetLabel(scale);
      scale.ticks = scale.ticks.reduce(function (acc, tick, index) {
        var label = getLabel(index, tick);
        acc.push({
          value: tick.value,
          label: label
        });
        return acc;
      }, []);
    } catch (e) {
      // оставляем пустым, т.к коллбэк ничего не должен возвращать
    }
  };
};
export var filterTicksVarA = _afterTickToLabelConversion(_filterVariantA);
export var filterTicksVarB = _afterTickToLabelConversion(_filterVariantB);